import { createTheme } from '@material-ui/core/styles'

const theme = createTheme({
    palette: {
        
    },
})
export default theme